/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import ReactOnRails from "react-on-rails";
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import PieChart from "../components/PieChart";
import PieChartNew from "../components/PieChartNew";
import LineChart from "../components/LineChart";
import Expenses from "../components/Expenses";
import EncryptedNote from "../components/EncryptedNote";
import RootPage from "../src/pages/RootPage";

Chart.register(ArcElement);
Chart.register(LineElement);
Chart.register(ChartDataLabels);
Chart.register(CategoryScale);
Chart.register(LinearScale);
Chart.register(PointElement);

Rails.start();

ReactOnRails.setOptions({ turbo: true, traceTurbolinks: true });
ReactOnRails.register({
  PieChart,
  PieChartNew,
  LineChart,
  Expenses,
  EncryptedNote,
  RootPage,
});

Turbolinks.start();

const scrollToReload = () => {
  let startY = 0;
  let isPulling = false;

  const pullToRefresh = document.getElementById("pull-to-refresh");
  const pullToRefreshIcon = document.getElementById("pull-to-refresh-icon");
  const content = document.getElementById("content");
  const REFRESH_THRESHOLD = 65; // Set the required pull distance to 124px

  // Listen for touch start
  content.addEventListener("touchstart", (e) => {
    if (window.turnOffPullToRefresh) return;

    if (window.scrollY === 0) {
      startY = e.touches[0].clientY;
      isPulling = true;
    }
  });

  // Listen for touch move
  content.addEventListener("touchmove", (e) => {
    if (window.turnOffPullToRefresh) return;

    if (!isPulling) return;

    const currentY = e.touches[0].clientY;
    const diffY = currentY - startY;

    if (diffY > 0) {
      e.preventDefault(); // Prevent scrolling
      pullToRefresh.style.top = `${Math.min(
        diffY - REFRESH_THRESHOLD,
        REFRESH_THRESHOLD
      )}px`;
    }
  });

  // Listen for touch end
  content.addEventListener("touchend", () => {
    if (window.turnOffPullToRefresh) return;

    if (!isPulling) return;

    isPulling = false;

    // Check if enough pull-down occurred
    if (parseInt(pullToRefresh.style.top, 10) >= REFRESH_THRESHOLD) {
      pullToRefresh.style.top = `${REFRESH_THRESHOLD}px`;
      pullToRefreshIcon.classList.add("spinning");
      refreshContent();
    } else {
      pullToRefresh.style.top = "-50px";
    }
  });

  function refreshContent() {
    location.reload();
  }
};

const setTheme = () => {
  const isDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const themeColor = isDarkTheme ? "#101827" : "#FFFFFF";
  document.getElementById("theme-color").setAttribute("content", themeColor);
};

document.addEventListener("turbolinks:render", function () {
  ReactOnRails.reactOnRailsPageLoaded();
});

document.addEventListener("turbolinks:load", function () {
  scrollToReload();
  setTheme();
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js");
}
